<template>
  <div>
    <div class="d-flex align-items-center bg-light border px-3 py-2" style="border-radius: 10px; border-color: #e2e8f0 !important">
      <font-awesome-icon :icon="['fas', 'lock-alt']" size="lg" class="mr-2 fs-17" />
      <span class="text-muted flex-grow-1" style="min-width: 0">
        Solicitud <strong class="text-dark">{{ closedLabel }}</strong>. Para hacer cambios, debe realizar la reapertura
      </span>
      <b-button
        variant="outline-secondary"
        class="font-weight-bold flex-shrink-0 ml-2"
        style="color: #163D7D; border-color: #c7d0dc; border-radius: 8px"
        @click="openModal"
      >
        Reaperturar
      </b-button>
    </div>

    <ConfirmModal
      v-if="modalShow"
      :required="true"
      :disabled="processing"
      @close="closeModal"
      @onConfirm="reopen"
    >
      <template #header>
        <h5 class="mb-0">Reaperturar solicitud</h5>
      </template>
      <template #body>
        <div class="text-left">
          <label for="reopen-reason" class="text-muted mb-1">
            Justificación<span class="text-danger ml-1">*</span>
          </label>
          <b-form-textarea
            id="reopen-reason"
            v-model="reason"
            rows="4"
            no-resize
            placeholder="Describa la razón de la reapertura…"
            :state="reasonState"
            :disabled="processing"
          />
          <div class="d-flex justify-content-between fs-12 mt-1">
            <span class="text-muted">Mínimo {{ MIN_REASON_LENGTH }} caracteres</span>
          </div>
        </div>

        <p v-if="processing" class="text-info fs-14 mt-3 mb-0">
          <b-spinner small class="mr-1" />
          Reabriendo...
        </p>
        <b-alert v-if="errorMessage" show variant="danger" class="fs-14 mt-3 mb-0 py-2">
          {{ errorMessage }}
        </b-alert>
      </template>
    </ConfirmModal>
  </div>
</template>

<script>
import ConfirmModal from '../../shared/ConfirmModal'

const MIN_REASON_LENGTH = 12

const CLOSED_LABELS = {
  entregado: 'entregada',
  desestimado: 'desestimada'
}

export default {
  name: 'DrawingRequestShowReopenBar',
  components: { ConfirmModal },
  props: {
    drawingRequestId: { type: Number, required: true },
    status: { type: String, required: true }
  },
  data () {
    return {
      MIN_REASON_LENGTH,
      modalShow: false,
      reason: '',
      processing: false,
      errorMessage: null
    }
  },
  computed: {
    closedLabel () {
      return CLOSED_LABELS[this.status] || 'cerrada'
    },
    reasonLength () {
      return this.reason.trim().length
    },
    isValid () {
      return this.reasonLength >= MIN_REASON_LENGTH
    },
    reasonState () {
      if (this.reasonLength === 0) return null
      return this.isValid ? true : null
    }
  },
  methods: {
    openModal () {
      this.reason = ''
      this.errorMessage = null
      this.modalShow = true
    },
    closeModal () {
      if (this.processing) return
      this.modalShow = false
      this.reason = ''
      this.errorMessage = null
    },
    reopen () {
      if (this.processing) return
      if (!this.isValid) {
        this.errorMessage = `La justificación debe tener al menos ${MIN_REASON_LENGTH} caracteres`
        return
      }

      this.processing = true
      this.errorMessage = null

      this.$http.post(`/api/production/drawing_requests/${this.drawingRequestId}/reopen`, {
        reopen: { reason: this.reason.trim() }
      })
        .then((res) => {
          this.processing = false
          this.closeModal()
          this.$emit('reopened', res.data)
          this.$bvToast.toast('La solicitud se reabrió y pasó a Correcciones', {
            title: 'Solicitud reabierta',
            variant: 'success',
            solid: true
          })
        })
        .catch((error) => {
          const response = error.response || {}
          const data = response.data || {}
          this.errorMessage = data.error || data.message || 'No se pudo Reaperturar la solicitud'
          this.processing = false

          if (response.status === 403) this.$emit('stale')
        })
    }
  }
}
</script>

<style scoped>
#reopen-reason ::placeholder {
  color: #5f6873;
  font-size: 16px;
}
</style>
